<template>
  <base-dialog
    :action="onAction"
    :action-name="'Save'"
    :close="onClose"
    :title="'Edit Coupon'"
  >
    <template #activator="{ on }">
      <slot
        name="activator"
        v-bind="{ on }"
      />
    </template>

    <template #content>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="name"
            type="text"
            placeholder="Name"
            hint="This will appear on customers' receipts and invoices."
            persistent-hint
            label="Name"
            outlined
            dense
          />
        </v-col>
      </v-row>

    </template>
  </base-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import BaseDialog from "../Common/BaseDialog"
import { isErrorResponse } from "../../services/util.service"

export default {
  components: { BaseDialog },
  props: {
    coupon: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      name: ''
    }
  },
  watch: {
    coupon() {
      this.name = this.coupon.name
    }
  },
  mounted() {
    this.name = this.coupon.name
  },
  methods:{
    ...mapActions(['updateCoupon']),
    onClose(){
      this.$emit('close')
    },
    onAction() {
      const payload = {
        id: this.coupon.id,
        name: this.name
      }

      return this.updateCoupon(payload)
        .then(res => {
          if (!isErrorResponse(res)) {
            this.$emit('action', payload)
          }
          return res
        })
    }
  }
}
</script>
